import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserState, User, UserToken } from "../../types";

const initialState: UserState = {
  user: null,
  token: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
    setUserToken: (state, action: PayloadAction<UserToken | null>) => {
      state.token = action.payload;
    },
  },
});

export const { setUser, setUserToken } = userSlice.actions;
export default userSlice.reducer;
